var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 14c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L5.6 7 .3 1.7C-.1 1.3-.1.7.3.3s1-.4 1.4 0l6 6c.4.4.4 1 0 1.4l-6 6c-.2.2-.4.3-.7.3z"}));
}

ChevronRight.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
